import { render, staticRenderFns } from "./UnbindAlipay.vue?vue&type=template&id=cd4a6e86&scoped=true&"
import script from "./UnbindAlipay.vue?vue&type=script&lang=js&"
export * from "./UnbindAlipay.vue?vue&type=script&lang=js&"
import style0 from "./UnbindAlipay.vue?vue&type=style&index=0&id=cd4a6e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4a6e86",
  null
  
)

export default component.exports